/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type courses_UpdateAttendanceRequest = {
    billing_type?: courses_UpdateAttendanceRequest.billing_type;
    comments?: string;
    status: courses_UpdateAttendanceRequest.status;
};
export namespace courses_UpdateAttendanceRequest {
    export enum billing_type {
        PER_MONTH = 'per_month',
        PER_UNIT = 'per_unit',
        FREE = 'free',
    }
    export enum status {
        PENDING = 'pending',
        APPROVED = 'approved',
        CANCELLED = 'cancelled',
    }
}

